import React from 'react';
import { createRoot } from 'react-dom/client';
import TimerBarOverlay from '../components/TimerBarOverlay';

export const launchTimerOverlay = async (sessionId, onOverlayClose, setOverlayActive) => {
  const hasPiP = 'documentPictureInPicture' in window;
  let pipWindow = null;

  try {
    if (hasPiP) {
      // 1. Asynchronously invoke requestWindow
      pipWindow = await window.documentPictureInPicture.requestWindow({
        width: 800,
        height: 60,
      });
    } else {
      // 2. Automated fallback rule: standard borderless popup
      pipWindow = window.open(
        'about:blank',
        'PresentlyOverlay',
        'width=800,height=60,menubar=no,toolbar=no,location=no,status=no,resizable=yes'
      );
      if (!pipWindow) {
        throw new Error('Popup blocked by browser. Please allow popups for Presently to enable floating overlay.');
      }
      
      // Ensure the blank document is initialized
      pipWindow.document.write('<!DOCTYPE html><html><head><title>Presently Live Timer</title></head><body></body></html>');
      pipWindow.document.close();
    }

    // 3. Style Injection: Dynamically iterate through stylesheets and copy them
    const styles = Array.from(document.styleSheets);
    styles.forEach((styleSheet) => {
      try {
        if (styleSheet.cssRules) {
          const newStyle = pipWindow.document.createElement('style');
          Array.from(styleSheet.cssRules).forEach((rule) => {
            newStyle.appendChild(pipWindow.document.createTextNode(rule.cssText));
          });
          pipWindow.document.head.appendChild(newStyle);
        } else if (styleSheet.href) {
          const newLink = pipWindow.document.createElement('link');
          newLink.rel = 'stylesheet';
          newLink.href = styleSheet.href;
          pipWindow.document.head.appendChild(newLink);
        }
      } catch (e) {
        // Fallback for CORS stylesheets
        if (styleSheet.href) {
          const newLink = pipWindow.document.createElement('link');
          newLink.rel = 'stylesheet';
          newLink.href = styleSheet.href;
          pipWindow.document.head.appendChild(newLink);
        }
      }
    });

    // Reset styles on body
    pipWindow.document.body.style.margin = '0';
    pipWindow.document.body.style.padding = '0';
    pipWindow.document.body.style.overflow = 'hidden';
    pipWindow.document.title = 'Presently Live Timer';

    // 4. Dynamically create mounting root and render
    const mountNode = pipWindow.document.createElement('div');
    mountNode.id = 'pip-root';
    pipWindow.document.body.appendChild(mountNode);

    const root = createRoot(mountNode);
    root.render(
      <TimerBarOverlay sessionId={sessionId} />
    );

    setOverlayActive(true);

    // 5. Listen for window events to reset active state toggle
    const handleClose = () => {
      try {
        root.unmount();
      } catch (e) {
        // Already unmounted
      }
      setOverlayActive(false);
      if (onOverlayClose) onOverlayClose();
    };

    pipWindow.addEventListener('pagehide', handleClose);
    pipWindow.addEventListener('beforeunload', handleClose);

    return pipWindow;
  } catch (error) {
    console.error('Failed to launch overlay:', error);
    // Graceful fallback to inline notification alert
    alert(error.message || 'Failed to launch overlay. Please ensure popups are enabled.');
    return null;
  }
};
